import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'Terminal',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.ruby.terminal.body',
        defaultMessage: 'Install the gem:',
      }),
    },
    command: 'gem install stripe',
    shell: true,
  },
  {
    label: 'Bundler',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.ruby.bundler.body',
        defaultMessage: 'Add this line to your Gemfile:',
      }),
    },
    command: "gem 'stripe'",
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.ruby.github.body',
        defaultMessage: 'Or download the stripe-ruby gem source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.ruby.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-ruby',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.ruby.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.ruby.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.ruby.setup.heading',
      defaultMessage: 'Install the Stripe Ruby library',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.ruby.setup.body',
      defaultMessage:
        'Install the Stripe ruby gem and require it in your code. If you are starting from scratch and need a Gemfile, download the project files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = 'ruby server.rb';
